import * as React from "react";
import {Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import {resourcesHelper} from "@ferry/portal-core";

interface IProps {
    className?: string;
    title: string;
}

interface IState {
    isOpen: boolean;
}

export class InfoModal extends React.Component<React.PropsWithChildren<IProps>, IState> {

    constructor(props: IProps) {
        super(props);

        this.state = {
            isOpen: false
        };

        this.toggle = this.toggle.bind(this);
    }

    public render() {
        return (
            <React.Fragment>
                <div className={`info-button cursor-pointer ${this.props.className}`} onClick={this.toggle}></div>
                <Modal className="my-2 info-modal" isOpen={this.state.isOpen} toggle={this.toggle}>
                    <ModalHeader toggle={this.toggle}>
                        <div className="info-popup-title">
                            <img src={`/${resourcesHelper.THEME_PATH}/img/info-popup.svg`} alt="Attention"/>
                            <div className="font-weight-bold">{this.props.title}</div>
                        </div>
                    </ModalHeader>
                    <ModalBody className="pt-0">
                        {this.props.children}
                    </ModalBody>
                    <ModalFooter>
                        <button type="button" className="btn btn-primary btn-next" onClick={this.toggle}>Ok, I understand</button>
                    </ModalFooter>
                </Modal>
            </React.Fragment>
        );
    }

    private toggle(): void {
        this.setState((state: IState) => ({
            isOpen: !state.isOpen
        }));
    }
}
